<template>
 <div>
  <div class="ln-login">
    <Form ref="form">
      <Field v-model="username" placeholder="账号" :rules="[{ required: true, message: '请填写账号' }]">
        <i slot="left-icon" class="iconfont iconuser"></i>
      </Field>
      <Password v-model="password" :passText="ispassword"></Password>
      <div class="bottom">
        <Row class="login-row">
          <Button class="login-btn" block type="info" @click="login">
            进入游戏
          </Button>
        </Row>

        <Row class="login-row" gutter="10" style="display: none;">
          <Col span="12" v-if="oldBtn"><Button block type="info" native-type="button" @click="guestLogin">快速注册</Button></Col>
          <Col span="12" v-if="!oldBtn"><Button block type="info" native-type="button" @click="guestStart">账号登录</Button></Col>
          <Col span="12"><Button block type="info" @click="register">手机注册</Button></Col>
        </Row>

        <Row class="login-row link-wrap" style="justify-content: space-between">
          <!-- <span class="link" @click="changeComponent('PhoneLogin')">手机登录</span> -->
          <span class="link" style="flex:1" @click="changeLoginPhone">手机登录</span>
          <span class="link"  @click="forgetPass">忘记密码?</span>
        </Row>

        <Row class="login-row link-wrap" style="justify-content:center;">
          <AgreeRegister v-model="agree"></AgreeRegister>
          <span style="font-size: 13px;margin-top: 7px;margin-left:5px;">同意游戏</span><span class="link" style="vertical-align:center;margin-left: 0px;margin-top: 7px;" @click="openProtocal(1)">《用户协议》</span>
          <span style="font-size: 13px;margin-top: 7px">及</span> <span style="font-size: 13px;margin-top: 7px;" @click="openProtocal(2)" class="link">《隐私协议》</span>
        </Row>
      </div>
    </Form>
    <!-- <van-icon style="position:absolute;right:0;top:0;right:10px;top:10px;" name="cross" @click="closeWindow" /> -->
  </div>
  <!-- 用户协议弹窗 -->
   <div v-if="isProto" class="lngame_proto">
     <div class="lngame_proto_con" style="height:100%;width:100%">
        <div style="height:90%;padding:15px">
          <iframe :src="userProtocol" style="width:100%;height:100%" frameborder="0"></iframe>
        </div>
      </div>
     <van-icon style="position:absolute;right:0;top:0;right:10px;top:10px;z-index:3000" name="cross" @click="closeProto" />
   </div>

   <!-- 删除账号 -->
     <DelAccount @backClick="backClick" v-if="isDelAcc"/>

  </div>
</template>

<script>
import cookies from '@/cookies';
import { Form, Field, Button, Col, Row, Dialog } from 'vant';
import { commonMixin } from '@/mixin';
import Password from '@/components/Password';
import AgreeRegister from '@/components/AgreeRegister';
import DelAccount from '@/components/DelAccount';
import { mapState } from 'vuex';
// 不能直接在这里解构，后续需检查 ！！
import server from '@/server';
import channelServer from '@/server/channelServer';
import { getUrlParams, getTopDomain } from '@/utils';
export default {
  name: 'ln-login',
  mixins: [commonMixin],
  components: { Form, Field, Button, Col, AgreeRegister, Row, DelAccount, Password },
  data() {
    return {
      username: '',
      password: '',
      agree: Boolean(localStorage.getItem('agreeProt')) || false,
      isProto: false,
      ispassword: 'password',
      oldBtn: true,
      userProtocol: '',
      isDelAcc: false,
      is_vertify: localStorage.getItem('ln_is_vertify'),
    };
  },
  computed: {
    ...mapState(['user', 'protocal_url', 'guestInfo', 'is_agree'])
  },
  created() {
    // channelServer.guestLogin();
    // 如果登录过默认取storage自动填充帐密
    if (localStorage.getItem('lnUserAccount') || cookies.getItem('lnUserPass')) {
      console.log(localStorage.getItem('lnUserAccount'))
      this.username = localStorage.getItem('lnUserAccount') || '';
      this.password = localStorage.getItem('lnUserPass') || '';
    }
    this.$store.commit('SET_COMPNAME', '账号登录');

    console.log(localStorage.getItem('ln_is_vertify'))
  },
  mounted() {
    const cookieUserName = cookies.getItem('ln_h5sdk_user_name');
    // const cookie_guestToken = cookies.getItem('ln_h5sdk_guest_token');
    // const cookie_userToken = cookies.getItem('ln_h5sdk_user_token');
    const storageUser = localStorage.getItem('lnUserAccount') || localStorage.getItem('userAccountguest');
    // 一个新设备首次激活（该设备没有在该应用中注册过账号）应用时，默认分配游客账号，点击注册即可登录。（此时原“游客登录”按钮变为“账号登录”）
    // if (!storageUser) {
    //   channelServer.guestLogin().then(() => {
    //     this.username = this.guestInfo.guestAccount;
    //     this.password = this.guestInfo.guestPass;
    //     this.ispassword = 'text';
    //     this.oldBtn = false;
    //     // this.$store.commit('SET_COMPNAME', '快速注册');
    //   })
    // }
    if (cookieUserName) {
      // this.username = cookieUserName;
    }
  },
  // watch: {
  //   is_agree: {
  //     handler(val) {
  //       this.agree = val;
  //     },
  //     immediate: true
  //   },
  // },
  methods: {
    // 进入游戏
    login() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      this.formCheck('form').then(() => {
        const params = {
          uname: this.username,
          upass: this.password
        };
        cookies.setItem('userAccount', this.username);
        cookies.setItem('userPass', this.password);
        localStorage.setItem('lnUserAccount', this.username);
        localStorage.setItem('lnUserPass', this.password);
        server.login(params);
      });
    },
    // 打开删除账号
    openDelAcc() {
      this.isDelAcc = true;
    },
    backClick(e) {
      this.isDelAcc = e;
    },
    guestStart() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      };
      this.$store.commit('SET_COMPNAME', '账号登录');
      this.oldBtn = true;
      this.username = '';
      this.password = '';
      // this.$store.commit('CLOSE');
    },
    register() {
      // if (!this.agree) {
      //   Dialog.alert({ message: '请先同意用户隐私协议' });
      //   return;
      // }
      // this.changeComponent('PhoneRegister');
      this.changeComponent('PhoneLogin');
    },
    forgetPass() {
      // if (!this.agree) {
      //   Dialog.alert({ message: '请先同意用户隐私协议' });
      //   return;
      // }
      // console.log(this.protocal_url);
      this.changeComponent('ForgetPassword');
    },
    closeWindow() {
      this.$store.commit('CLOSE');
    },
    changeLoginPhone() {
      this.$store.commit('SHOW', {
        name: 'PhoneLogin'
      })
    },
    guestLogin() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      this.oldBtn = false;
      cookies.setItem('userAccount', this.username);
      cookies.setItem('userPass', this.password);
      this.$store.commit('SET_COMPNAME', '快速注册');
      // localStorage.setItem('lnUserAccount', this.username);
      // localStorage.setItem('lnUserPass', this.password);
      // channelServer.guestLogin();
      // setTimeout(() => {
      //   this.username = this.guestInfo.guestAccount || this.user.account;
      //   this.password = this.guestInfo.guestPass || this.user.passwd;
      // }, 400);
      channelServer.guestLogin().then(data => {
        this.username = localStorage.getItem('lnUserAccount') || this.user.account;
        this.password = localStorage.getItem('lnUserPass') || this.user.passwd;
      })
    },
    // 打开用户协议
    openProtocal(type) {
      this.isProto = true;
      this.userProtocol = type == 1 ? `${getTopDomain('apisdk')}/uc/user/user_protocol?appid=${getUrlParams('appid')}` : `${getTopDomain('apisdk')}/uc/user/privacy_protocol?appid=${getUrlParams('appid')}`
    },
    closeProto() {
      this.isProto = false;
    }
  }
};
</script>
<style lang="scss">
/* @import url() */
.ln-login {
}
.lngame_proto{position: fixed;width: 100%;top: 0;left: 0;height: 100%;z-index: 2002;background: rgba(0, 0, 0, 0.4);}
.lngame_proto_con{width: 100%;height: 350px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);}
</style>
